import React, { ForwardedRef } from "react"

type props = {
  id: string;
  label?: string;
  className?: string;
  children?: React.ReactNode;
  value?: any;
  dot?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement> | any;
  color?: "blue" | "green" | "red" | "yellow" | "indigo";
  [key: string]: any;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  selectItems: SelectItem[];
  selectClassName: string;
  vertical?: boolean;
  centering?: string;
};

export type SelectItem = {
  id: string,
  name: string,
  value?: any,
}

type lableProps = {
  id: string;
  label?: string;
  type?: string;
  className?: string;

  children?: React.ReactNode;
  color?: "blue" | "green" | "red" | "yellow" | "indigo";
  [key: string]: any;
};

const styles = {
  rounded: `rounded-full`,
  block: `flex justify-center w-full`,
  error: `border-red-300 ring-red-500 ring-1 focus:ring-red-500 focus:border-red-500`,
  errorMessage: `text-xs text-red-500 mt-2`,
  default: `text-white focus:outline-none shadow font-medium transition ease-in duration-200`,
  disabled: `opacity-60 cursor-not-allowed`,
  sizes: {
    sm: "px-6 py-1 text-sm",
    md: "px-6 py-2",
    lg: "px-6 py-3 text-lg",
  },
  colors: {
    blue: "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
    green: "border-gray-300 focus:border-green-500 focus:ring-green-500",
    red: "border-gray-300 focus:border-red-500 focus:ring-red-500",
    yellow: "border-gray-300 focus:border-yellow-500 focus:ring-yellow-500",
    indigo: "border-gray-300 focus:border-indigo-500 focus:ring-indigo-500",
  },
  vertical: " sm:flex sm:items-center sm:space-y-0 sm:space-x-10",
};

export const Label = ({
  id,
  children,
  className = "mb-1 block text-sm font-medium text-gray-700",
}: lableProps) => {
  return (
    <label htmlFor={id} className={className}>
      {children}
    </label>
  );
};

type FieldRef = ForwardedRef<never>;
export const SelectFields = React.forwardRef((
  {
    id,
    label,
    className = "h-20",
    value,
    onChange,
    color = "indigo",
    error,
    helperText,
    required,
    selectItems,
    selectClassName = "",
    vertical = false,
    centering = "",
    ...props
  }: props,
  ref: FieldRef
) => {
  return (
    <>
      <div ref={ref} className={`${vertical ? styles.vertical : ""} ${className}`}>
        <div className={`flex ${vertical && centering !== "" ? ` basis-${centering} justify-end` : ""}`}><Label id={id}>{label}</Label>{required && <div className="text-red-500 mx-1">*</div>}</div>
        <select
          id={id}
          onChange={onChange}
          value={value}
          {...props}
          className={`p-1 border h-8 block w-full pr-12 rounded-md border-gray-300 shadow-sm text-sm ${styles.colors[color]} ${vertical ? styles.vertical : ""}${vertical && centering !== "" ? " basis-1/2" : ""} ${selectClassName}`}
        >
        {selectItems.map((item) => {
          return (
            <option key={`${id}-${item.id}`} value={item.value ?? item.id}>
              {item.name}
            </option>
          );
        })}
        </select>
        {error && (
          <span role="alert" className={styles.errorMessage}>
            {helperText}
          </span>
        )}
      </div>
    </>
  )
});